<template>
  <a-dropdown placement="bottomLeft" trigger="click" :arrow="false">
    <template #overlay>
      <div class="bg">
        <a-menu>
          <a-menu-item
            v-for="(i, index) in props.options"
            :key="index"
            :disabled="i.disabled"
            @click="menuClick(i)"
          >
            <span :style="i.style">{{ i.text }}</span>
          </a-menu-item>
        </a-menu>
      </div>
    </template>
    <div class="item-options" @click.stop>
      <slot>
        <EllipsisOutlined class="fs-16 fw-7" />
      </slot>
    </div>
  </a-dropdown>
</template>

<script setup>
import { Dropdown as ADropdown, Menu as AMenu, MenuItem as AMenuItem } from 'ant-design-vue'
import { EllipsisOutlined } from '@ant-design/icons-vue'

const props = defineProps({
  options: {
    type: Array,
    default: () => []
  },
  data: {
    type: Object,
    default: () => ({})
  }
})

const menuClick = (i) => {
  i.fnClick && i.fnClick(props.data)
}
</script>

<style lang="less" scoped>
.item-options {
  padding: 0 4px;
  position: sticky;
  right: 0;
  background-color: #fff;
  padding-right: 4px;
}
.bg {
  background-color: #fff;
}
</style>
